export default __webpack_public_path__ + "static/media/midia_desabonadora.b138615b.svg";